<template>
	<div class="xiangmu">
		<breadcrumb :routerList="[{to:'/dingd/material/bsc',title:'订单管理'}]"/>
		<div class="h-piece h-mrt30">
			<div class="h-formBox">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<el-form-item label="分类">
						<el-select v-model="formInline.customerName" style="width:2rem">
							<el-option label="客户一" value="1"></el-option>
							<el-option label="客户二" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单类型">
						<el-select v-model="formInline.lei"  style="width:2rem">
							<el-option label="客户一" value="1"></el-option>
							<el-option label="客户二" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="物料编码">
						<el-select v-model="formInline.ma"  style="width:1.5rem">
							<el-option label="类别1" value="1"></el-option>
							<el-option label="类别2" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="产品型号">
						<el-select v-model="formInline.type"  style="width:1.5rem">
							<el-option label="类别1" value="1"></el-option>
							<el-option label="类别2" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="h-formBtnOut">
						<el-button class="h-btn h-formBtn">检索</el-button>
						<el-button class="h-btn h-formBtn" @click="resetData" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
					</el-form-item>
					</el-form>
			</div>
	</div>
		<div class="h-table h-mrt30" v-if="clickActive==1">
		<el-table
				ref="multipleTable"
				@selection-change="handleSelectionChange"
			:data="tableData2"
			@header-click="headerClick"
			stripe
			border
			style="width: 100%"
			>
			<el-table-column
				type="selection"
				width="70"
				:label="all"
				>
			</el-table-column>
			<el-table-column
				fixed
				type="index"
				label="序号"
				width="50">
			</el-table-column>
			<el-table-column
				prop="customerName"
				label="分类"
				width="60">
			</el-table-column>
			<el-table-column
				prop="visitTime"
				label="订单类型"
				:show-overflow-tooltip="true"
				width="100">
			</el-table-column>
			<el-table-column
				prop="contact"
				label="产品名称"
				:show-overflow-tooltip="true"
				width="100">
			</el-table-column>
			<el-table-column
				prop="objective"
				label="物料编码"
				:show-overflow-tooltip="true"
				width="100">
			</el-table-column>
			<el-table-column
				prop="category"
				label="产品型号"
				:show-overflow-tooltip="true"
				width="100">
			</el-table-column>
			<el-table-column
				prop="status"
				label="订单数量"
				width="80">
			</el-table-column>
					<el-table-column
				prop="price"
				label="基准价"
				width="80">
			</el-table-column>
					<el-table-column
				prop="clinch"
				label="成交价"
				width="100">
			</el-table-column>
					<el-table-column
				prop="totalP"
				label="总价"
				width="100">
			</el-table-column>
			<el-table-column
				label="操作"
			>
				<template slot-scope="scope">
				<el-button
					type="text"
					size="small"
					class="h-tableLink h-btn">
						查看详情
				</el-button>
					<el-button
						type="text"
						size="small"
						class="h-tableLink h-btn">
						盈利测算
					</el-button>
					<!-- <div class="l-operationBox">
						<span class="l-operationlist br-operation-look" title="查看详情"></span>
						<span class="l-operationlist br-operation-ylcs" title="盈利测算"></span>
					</div> -->
				</template>
			</el-table-column>
		</el-table>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;">批量导出</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="daoru">批量导入</el-button>
				</div>
				<div class="h-pagination2">
					<span class="h-pagiLabel">显示数量:</span>
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="4"
						:page-sizes="[10, 20, 30, 40]"
						:page-size="10"
						layout="sizes, prev, pager, next,jumper"
						:total="400">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
			<div class="h-dialogImg">
				<div style="display:flex;align-items:center;">
					<img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
					<div>
							<p class="piliang1">批量导入</p>
							<p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
					</div>
				</div>
				
				<div class="piliangBox">
					<div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
													style="width: 40px;height: 39px;"></div>
					<div class="imgs">批量导入模版文件.xlsx</div>
					<div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
				</div>
				<div style="width:100%;">
					<el-upload
								action="https://jsonplaceholder.typicode.com/posts/"
								list-type="picture-card"
								:on-preview="handlePictureCardPreview"
								:on-remove="handleRemove"
								style="width:100%;">
							<div style="width:100%;">+ 上传文件</div>
					</el-upload>
				</div>
				<div style="display:flex;justify-content:center;margin-top:30px;">
					<el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
							取消
					</el-button>
					<el-button class="h-btn h-formBtn" type="primary" style="margin-left:40px;"
									@click="dialogFormVisible2 = false">提交
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data(){
      return{
			dialogFormVisible2:false,
			//表单
			all:'全部',
			formInline:{
				customerName:'',
				type:'',
				guanxi:'',
				lei:'',
				
				ma:''
			},
			//表格
			multipleSelection: [],
			tableData2: [{
                customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
                },
                {
				customerName: '自产',
                visitTime:'标准类型',
                contact: 'XXX产品',
                objective: 'KHS385',
                category: 'SJHSLT348',
                status: '32',
                price:'5,000,000',
                clinch:'5,000,000',
                totalP:'5,000,000'
				}],
				clickActive:1
      }
    },
	methods:{
		daoru() {
			this.dialogFormVisible2 = true;
		},
		//表格
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 重置按钮
		resetData(){
			this.formInline.customerName = ""
			this.formInline.lei = ""
			this.formInline.type = ""
			this.formInline.ma = ""
			this.$message({
				type: "success",
				message: '已成功重置'
			});
		},
		lineChart(){
			let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
			let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer:{
						show: true,
						lineStyle: {
							width : 1,
							color:'#61a0f7'
						}
				   }
				},
				legend: {
					show:false
				},
				calculable: true,
				
				yAxis: [{
					type: 'value',
					axisLine: {
						show:false
					},
					splitLine: {
						show:false
					},
					axisTick:{
						show:false
					},
					axisLabel: {
						show:false
					}
				}],
				series: [{
						name: '跑步排名',
						type: 'line',
						symbol: 'circle',
						symbolSize: 0,
						showSymbol: false,
						areaStyle:{
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0, color: 'rgba(145,188,250,1)' // 0% 处的颜色
								},{
									offset: 0.5, color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
								}, {
									offset: 1, color: 'rgba(145,188,250,0)' // 100% 处的颜色
								}],
								globalCoord: false // 缺省为 false
							},
						},
						smooth:true,
						data: [30,58,98,52,68,30,88],
						lineStyle:{
							color:'#61a0f7'
						},
						itemStyle: {
							normal: {
								color: '#ffffff',
								borderColor: '#61a0f7',
								borderWidth: 2
							}
						}
					}
				]
			};
			lineChart.setOption(option);
		}
	  },
	  mounted(){
		  this.lineChart();
	  },
}
</script>
<style scoped>
	.xiangmu>.h-piece, .h-mrt30{
   	    margin: 20px;
    } 
	.h-formBtnOut  .h-mr20{
		margin-left:1rem !important;
	}
    
</style>
<style>
/* .el-table__header .el-table-column--selection .cell .el-checkbox::after{
    content: "全选";
    color:white;
    background-color: rgb(93, 172, 236);
} */
.h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        
        margin-bottom: 20px;
    }
    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;
        
    }
</style>


